import $ from 'jquery';
import { spring } from "motion"
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

window.$ = $;
window.Swiper = Swiper;


$(window).on('scroll', () => {
    $('header.main').toggleClass('sticky', $(window).scrollTop() > 50);
});

$('footer button').on('click', function (optionsOrVisualDuration) {
    $('html, body').animate({ scrollTop: 0 }, optionsOrVisualDuration);
});

const cta = $('.call-to-action');
cta.find('span, button').on('click', function (event) {
    event.preventDefault();
    cta.toggleClass('active');
});

$('.hamburger').on('click', function (event) {
    event.preventDefault();
    $('.navigation').toggleClass('active');
    $('.navigation-button').toggleClass('active');
    $('body').toggleClass('stop-scroll');
});

// Chevron-Button in alle nav.main li mit Child-UL injizieren
$('nav.main ul > li').filter(function () {
    return $(this).children('ul').length > 0;
}).each(function () {
    $(this).append('<button class="nav-toggle" aria-expanded="false" aria-label="Untermenü öffnen"></button>');
});

// Mobile: Sub-Nav per Chevron oder Link togglen
function toggleSubNav($li) {
    const isOpen = $li.hasClass('open');
    $li.siblings('li.open').removeClass('open').find('> .nav-toggle').attr('aria-expanded', 'false');
    $li.toggleClass('open', !isOpen);
    $li.find('> .nav-toggle').attr('aria-expanded', String(!isOpen));
}

$(document).on('click', '.navigation.active nav.main .nav-toggle', function () {
    toggleSubNav($(this).closest('li'));
});

$(document).on('click', '.navigation.active nav.main li:has(.nav-toggle) > a', function (e) {
    e.preventDefault();
    toggleSubNav($(this).closest('li'));
});